.font-normal {
  font-weight: 400 !important;
}